var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSoundCircle48Filled = function SvgIconSoundCircle48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 12.2c-3.11-3.16-7.28-4.9-11.74-4.9-9.19 0-16.8 7.48-16.96 16.67-.08 4.47 1.59 8.67 4.7 11.83 3.11 3.16 7.28 4.9 11.74 4.9 9.19 0 16.8-7.48 16.96-16.67.08-4.47-1.59-8.67-4.7-11.83ZM19.7 28h-3.4v-8h3.4v8Zm6 4h-3.4V16h3.4v16Zm6-3h-3.4V19h3.4v10Z",
    fill: "current"
  })));
};
export default SvgIconSoundCircle48Filled;